import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/ui/loaders';

// ------- SAGA ------ //

function changeStatusLoadingFetchCoverage(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingFetchCoverage = isLoading;
}

function changeStatusLoadingFetchExecutive(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingFetchExecutive = isLoading;
}

function changeStatusLoadingRegisterPersonalData(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingRegisterPersonalData = isLoading;
}

function changeStatusLoadingValidatePersonalData(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingValidatePersonalData = isLoading;
}

function changeStatusLoadingValidateIdentity(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingValidateIdentity = isLoading;
}

function changeStatusLoadingPreferences(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingPreferences = isLoading;
}

function changeStatusLoadingAdditional(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingAdditional = isLoading;
}

function changeStatusLoadingValidateSignature(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingValidateSignature = isLoading;
}

function changeStatusLoadingFetchSignature(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingFetchSignature = isLoading;
}

function changeStatusLoadingConfirmPaymentButton(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingConfirmPaymentButton = isLoading;
}

function changeStatusLoadingGeneratePaymentButton(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingGeneratePaymentButton = isLoading;
}

function changeStatusLoadingFetchSignatureSavingsAccount(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingFetchSignatureSavingsAccount = isLoading;
}

function changeStatusLoadingValidateSignatureSavingsAccount(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingValidateSignatureSavingsAccount = isLoading;
}

function changeStatusLoadingFetchProductOffers(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingFetchProductOffers = isLoading;
}

function changeStatusLoadingValidateOtp(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingValidateOtp = isLoading;
}

function changeStatusLoadingFetchOtp(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingFetchOtp = isLoading;
}

function changeStatusLoadingCreatePassword(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingCreatePassword = isLoading;
}

function changeStatusLoadingContactConsumerCredit(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingContactConsumerCredit = isLoading;
}

function changeStatusLoadingDocuments(state, action) {
  const { isLoading, name } = action.payload;
  state.isLoadingDocuments = { isLoading, name };
}

function changeStatusLoadingRegisterSurvey(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingRegisterSurvey = isLoading;
}

const LoadingFetchCoverage = createAction('LoadingFetchCoverage');
const LoadingValidateIdentity = createAction('LoadingValidateIdentity');
const LoadingValidatePersonalData = createAction('LoadingValidatePersonalData');
const LoadingRegisterPersonalData = createAction('LoadingRegisterPersonalData');
const LoadingRegisterSurvey = createAction('LoadingRegisterSurvey');
const LoadingPreferences = createAction('LoadingPreferences');
const LoadingAdditional = createAction('LoadingAdditional');
const LoadingFetchSignature = createAction('LoadingFetchSignature');
const LoadingValidateSignature = createAction('LoadingValidateSignature');
const LoadingGeneratePaymentButton = createAction('LoadingGeneratePaymentButton');
const LoadingConfirmPaymentButton = createAction('LoadingConfirmPaymentButton');

const LoadingFetchSignatureSavingsAccount = createAction('LoadingFetchSignatureSavingsAccount');
const LoadingValidateSignatureSavingsAccount = createAction('LoadingValidateSignatureSavingsAccount');
const LoadingFetchProductOffers = createAction('LoadingFetchProductOffers');
const LoadingFetchOtp = createAction('LoadingFetchOtp');
const LoadingValidateOtp = createAction('LoadingValidateOtp');
const LoadingCreatePassword = createAction('LoadingCreatePassword');
const LoadingContactConsumerCredit = createAction('LoadingContactConsumerCredit');
const LoadingDocuments = createAction('LoadingDocuments');
const LoadingFetchExecutive = createAction('LoadingFetchExecutive');

const loadingReducer = createSlice({
  name: 'loaders',
  initialState,
  reducers: {
    changeStatusLoadingFetchCoverage,
    changeStatusLoadingRegisterPersonalData,
    changeStatusLoadingValidatePersonalData,
    changeStatusLoadingValidateIdentity,
    changeStatusLoadingPreferences,
    changeStatusLoadingAdditional,
    changeStatusLoadingFetchSignature,
    changeStatusLoadingFetchSignatureSavingsAccount,
    changeStatusLoadingValidateSignatureSavingsAccount,
    changeStatusLoadingValidateSignature,
    changeStatusLoadingFetchProductOffers,
    changeStatusLoadingFetchOtp,
    changeStatusLoadingValidateOtp,
    changeStatusLoadingCreatePassword,
    changeStatusLoadingContactConsumerCredit,
    changeStatusLoadingDocuments,
    changeStatusLoadingFetchExecutive,
    changeStatusLoadingGeneratePaymentButton,
    changeStatusLoadingConfirmPaymentButton,
    changeStatusLoadingRegisterSurvey,
  },
});

export const loadingActions = {
  ...loadingReducer.actions,
  LoadingValidateIdentity,
  LoadingValidatePersonalData,
  LoadingRegisterPersonalData,
  LoadingFetchProductOffers,
  LoadingFetchCoverage,
  LoadingPreferences,
  LoadingAdditional,
  LoadingFetchSignature,
  LoadingValidateSignature,
  LoadingGeneratePaymentButton,
  LoadingConfirmPaymentButton,
  LoadingFetchSignatureSavingsAccount,
  LoadingValidateSignatureSavingsAccount,
  LoadingFetchOtp,
  LoadingValidateOtp,
  LoadingCreatePassword,
  LoadingContactConsumerCredit,
  LoadingDocuments,
  LoadingFetchExecutive,
  LoadingRegisterSurvey,
};

export default loadingReducer.reducer;
